var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "rb-header-base-side-panel",
    _vm._b(
      {
        staticClass: "rb-header-omnichannel-side-panel",
        attrs: {
          variant: "omnichannel",
          "wcag-hidden-button-is-focusable": _vm.wcagHiddenButtonIsFocusable,
        },
        on: { overlayClicked: _vm.closePanel },
        scopedSlots: _vm._u([
          {
            key: "content",
            fn: function () {
              return [_c("rb-header-omnichannel")]
            },
            proxy: true,
          },
        ]),
      },
      "rb-header-base-side-panel",
      _vm.$props,
      false
    )
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }